import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CategoryMenu.css';

// Import custom icons
import chickenIcon from '../assets/animal_16499540.png';
import petIcon from '../assets/pet-dog_16946906.png';
import cattleIcon from '../assets/animal.png';
import goatIcon from '../assets/goat_4081970.png';

const CategoryMenu = () => {
  const navigate = useNavigate();

  const categories = [
    {
      id: 'chickens',
      name: 'Chickens',
      icon: <img src={chickenIcon} alt="Chickens" className="category-icon-img" />,
      description: 'Buy and sell chickens, hens, and roosters'
    },
    {
      id: 'pets',
      name: 'Pets',
      icon: <img src={petIcon} alt="Pets" className="category-icon-img" />,
      description: 'Find your perfect pet companion'
    },
    {
      id: 'cattle',
      name: 'Cattle',
      icon: <img src={cattleIcon} alt="Cattle" className="category-icon-img" />,
      description: 'Trade cattle and dairy animals'
    },
    {
      id: 'sheep-goat',
      name: 'Sheep/Goat',
      icon: <img src={goatIcon} alt="Sheep/Goat" className="category-icon-img" />,
      description: 'Buy and sell sheep and goats'
    }
  ];

  const handleCategoryClick = (categoryId) => {
    navigate(`/post-ad/${categoryId}`);
  };

  return (
    <div className="category-menu">
      <h2 className="category-menu-title">Select Category</h2>
      <div className="category-grid">
        {categories.map((category) => (
          <div
            key={category.id}
            className="category-card"
            onClick={() => handleCategoryClick(category.id)}
          >
            <div className="category-icon">{category.icon}</div>
            <h3 className="category-name">{category.name}</h3>
            <p className="category-description">{category.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryMenu; 